import { getMessage } from '@tcc/i18n';
import {
  Button,
  ButtonFill,
  ButtonWidth,
  ComponentColor,
  ComponentPadding,
  ComponentSize,
  ComponentStrength,
  Container,
  DensitySpacing,
  FdsIcon,
  Icon,
  Orientation,
  Typography,
  TypographyVariant,
  ComponentFill,
} from '@tcc/fds';
import styles from '../RegionReport.css';
import { getAverageYieldText } from '../../../../utils/regionUtils'

export type RegionReportItemHeaderProps = {
  areaUnit: string;
  cropCode: string;
  headerText: string;
  isCollapsed: boolean;
  toggleCollapsed: () => void;
};
export const RegionReportItemHeader = ({
  areaUnit,
  cropCode,
  headerText,
  isCollapsed,
  toggleCollapsed,
}: RegionReportItemHeaderProps) => {
  const averageYieldText = getMessage(getAverageYieldText(cropCode));

  return (
    <Container
      orientation={Orientation.Horizontal}
      testId="frr-header-item"
      color={ComponentColor.Neutral}
      strength={ComponentStrength.Strong}
      fill={ComponentFill.Clean}
      padding={ComponentPadding.Container}
      gap={DensitySpacing.None}
      >
      <Container width='50%' className={styles.alignLeft}>
        <Button
          fill={ButtonFill.Outline}
          iconOnly
          width={ButtonWidth.FitContent}
          onClick={toggleCollapsed}
          color={ComponentColor.Neutral}
          testId='frr-header-item-toggle-button'
          size={ComponentSize.Sm}
          aria-label={isCollapsed ? getMessage('expand') : getMessage('collapse')}>
          <Icon icon={isCollapsed ? FdsIcon.KeyBoardArrowDown : FdsIcon.KeyBoardArrowUp} />
        </Button>
        <Typography tag='span' variant={TypographyVariant.Label} testId={`frr-header-item-${headerText}`}>
          {headerText}
        </Typography>
      </Container>
      <Typography
        width='25%'
        variant={TypographyVariant.Label}
        testId="dmb-region-report-item-header-area-unit-text"
        className={styles.alignRight}>
        {areaUnit}
      </Typography>
      <Typography
      width='25%'
      variant={TypographyVariant.Label}
      testId="dmb-region-report-item-header-avg-yield-text"
      className={styles.alignRight}>
        {averageYieldText}
      </Typography>
    </Container>
  );
};
